export default __webpack_public_path__ + "238dc05e1e9c07f7afa3f1e140472c92.svg";